export async function fetchWithRedirect(
  url,
  options = {},
  no401Redicect = false,
) {
  try {
    const response = await fetch(url, options);
    // Handle status code 500 by redirecting to an error page
    if (response.status === 500) {
      window.location.href = "/server-error"; // Redirect to error page
      return null; // Prevent further processing
    } else if (response.status === 401) {
      if (!no401Redicect) {
        let forceLogout = false;
        let temp_data = await response.clone().json();
        if (String((await temp_data).detail).startsWith("Sesja wygasła")) {
          forceLogout = true;
        }
        window.location.href =
          "/zaloguj-sie?next=" +
          window.location.pathname +
          "&logout=" +
          forceLogout;
      }
    }
    const data = await response.json();

    let message = response?.isOk ? "" : "Coś poszło nie tak...";
    if (Array.isArray(data?.detail)) {
      message = data?.detail
        .map((err) => `${err.loc?.join(".") || "Błąd"}: ${err.msg}`)
        .join("; ");
    } else if (typeof data.detail === "string") {
      message = data.detail;
    }
    return {
      isOk: response?.ok,
      data,
      message,
      status: response?.status,
    };
  } catch (err) {
    console.error(err);
    return {
      isOk: false,
      message: "Wystąpił błąd podczas komunikacji z serwerem.",
    };
  }
}
